import { Spin } from "antd";

import { FIELD_PREVIEW_DEFAULT_VALUE } from "@/components/Elements/FieldPreview/FieldPreview.constant";
import { capitalize } from "@/utilities/string";

const DynamicLevelPreview = ({ field, level, loading }) => {
  if (loading)
    return (
      <span role="status">
        <Spin size="small" />
      </span>
    );

  if (!field || !level) return FIELD_PREVIEW_DEFAULT_VALUE;

  if (typeof level === "number") return <div role={field}>{level}</div>;

  return <div role={field}>{capitalize(level.name)}</div>;
};

export default DynamicLevelPreview;
